import Vue from 'vue'
import '@/core/plugins/vuelidate'
import '@/core/plugins/directives'
import '@/core/plugins/bootstrap'
import '@/core/plugins/smooth-scroll'
import '@/core/plugins/gmaps'
import '@/core/plugins/abilities'
import '@/core/plugins/recaptcha'
import '@/core/plugins/v-mask'

import '@/core/styles/app.styl'

// Hamburger Css https://jonsuh.com/hamburgers/
import 'hamburgers/dist/hamburgers.min.css'
// https://remixicon.com/
import 'remixicon/fonts/remixicon.css'

import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false;

let deferredPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  // Evita que Chrome muestre su mini-infobar
  e.preventDefault();

  deferredPrompt = e;

  window.dispatchEvent(new Event('pwa-install-available'));
});

Vue.prototype.$getPwaDeferredPrompt = function () {
  return deferredPrompt;
};

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  window.dispatchEvent(new Event('pwa-installed'));
});

Vue.prototype.$clearPwaDeferredPrompt = function () { deferredPrompt = null; };

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
